export const LS_REPORTING_MODE_KEY = 'reporting_mode_show';

export const REPORTING_MODES = {
  TRANSPARENT: 'TRANSPARENT',
  OPAQUE: 'OPAQUE',
};

export const REPORTING_MODES_INFO = {
  [REPORTING_MODES.TRANSPARENT]: {
    title: 'Transparent',
  },
  [REPORTING_MODES.OPAQUE]: {
    title: 'Opaque',
  },
};

export const REPORTING_STATUS = {
  AWAITING: 'AWAITING',
  UPLOADED_ON_TIME: 'UPLOADED_ON_TIME',
  UPLOADED_ON_GRACE: 'UPLOADED_ON_GRACE',
  UPLOADED_LATE: 'UPLOADED_LATE',
  OVERDUE: 'OVERDUE',
};

export const APPLICATION_REPORTING_STATUS = {
  PENDING: 'PENDING',
  ON_TIME: 'ON_TIME',
  GRACE_OK: 'GRACE_OK',
  LATE: 'LATE',
  MISSED: 'MISSED',
};

export const REPORTING_DOCS_STATUS = {
  NEW: 'NEW',
  PASS: 'PASS',
  FAIL: 'FAIL',
  REVIEW: 'REVIEW',
};

export const REPORTING_DOCUMENTS = {
  balance_sheet: 'balance_sheet',
  pnl: 'pnl',
  cash_flow: 'cash_flow',
  bank_statement: 'bank_statement',
  loan_agreement: 'loan_agreement',
};
